export const reduxKey = '@@HEAD';
